const ELLIPSIS = "…";

/**
 * Truncate `value` to `maxLength`, centering the window on the first occurrence of `query` so the
 * match itself is never cut off (e.g. when it falls near the end of a long value).
 */
export default function buildMatchSnippet(value: string, query: string, maxLength = 60): string {
  if (value.length <= maxLength) {
    return value;
  }

  const matchIndex = query ? value.toLowerCase().indexOf(query.toLowerCase()) : -1;
  if (matchIndex === -1) {
    return `${value.slice(0, maxLength)}${ELLIPSIS}`;
  }

  const contextBefore = Math.floor((maxLength - Math.min(query.length, maxLength)) / 2);
  const start = Math.max(0, Math.min(matchIndex - contextBefore, value.length - maxLength));
  const end = start + maxLength;

  const prefix = start > 0 ? ELLIPSIS : "";
  const suffix = end < value.length ? ELLIPSIS : "";
  return `${prefix}${value.slice(start, end)}${suffix}`;
}
